import { Module } from '@codewyre/wyrekit-composition';

class RouterModule extends Module {
  static routes$;
}

function routes(...routes2) {
  return (constructor) => {
    constructor.routes$ = routes2;
    return constructor;
  };
}

export { RouterModule, routes };
//# sourceMappingURL=index.es.js.map
